import React from "react";
import cx from "classnames";
import { color } from "..";
import { css } from "@linaria/core";

const Spinner = (
  { className, ...props }: React.SVGProps<SVGSVGElement>,
  forwardedRef: React.Ref<SVGSVGElement>,
) => (
  <svg ref={forwardedRef} className={cx(spinner, className)} viewBox="0 0 100 100" {...props}>
    <circle stroke={props.color ?? color.lightNitrogen500_Main} cx="50" cy="50" r="45" />
  </svg>
);

const spinner = css`
  @keyframes svg-circle-animation {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }

  animation: 2.2s linear infinite svg-circle-animation;

  @keyframes circle-animation {
    0%,
    25% {
      stroke-dashoffset: 280;
      transform: rotate(0);
      opacity: 1;
    }

    50%,
    75% {
      stroke-dashoffset: 75;
      transform: rotate(90deg);
      opacity: 1;
    }

    100% {
      stroke-dashoffset: 280;
      transform: rotate(360deg);
      opacity: 1;
    }
  }

  circle {
    animation: 2.5s linear infinite both circle-animation;
    display: block;
    fill: transparent;
    stroke-linecap: square;
    stroke-dasharray: 280;
    stroke-dashoffset: 283;
    stroke-width: 6px;
    transform-origin: 50% 50%;
  }
`;

export default React.memo(React.forwardRef(Spinner));
